import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import { AccountsAPI } from '../store/api/account';
import { ServicesAPI, BookingsAPI, ProductsAPI, ProjectsAPI } from '../store/api/services';

export const store = configureStore({
  reducer: {
    user: userReducer,
    [AccountsAPI.reducerPath]:  AccountsAPI.reducer,
    [ServicesAPI.reducerPath]:  ServicesAPI.reducer,
    [BookingsAPI.reducerPath]:  BookingsAPI.reducer,
    [ProductsAPI.reducerPath]:  ProductsAPI.reducer,
    [ProjectsAPI.reducerPath]:  ProjectsAPI.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(AccountsAPI.middleware)
      .concat(ServicesAPI.middleware)
      .concat(BookingsAPI.middleware)
      .concat(ProductsAPI.middleware)
      .concat(ProjectsAPI.middleware),
});
